import { render, staticRenderFns } from "./FullLayout.vue?vue&type=template&id=645afc16"
import script from "./FullLayout.vue?vue&type=script&lang=js"
export * from "./FullLayout.vue?vue&type=script&lang=js"
import style0 from "./FullLayout.vue?vue&type=style&index=0&id=645afc16&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports